import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { BsInfoCircle, BsX } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import usePremium from "../../hooks/usePremium";
import useQrCount from "../../hooks/useQrCount";
import { setIsQrLimitForceShow } from "../../redux/slices/modals";
import "./qrLimitToast.scss";

const QR_LIMIT_CLOSED_KEY = "qrLimitClosedAtCount";

function renderLabel(template, values) {
  if (!template) return null;

  return template.split(/(\{count\}|\{limit\})/g).map((part, index) => {
    if (part === "{count}") return <b key={index}>{values.count}</b>;
    if (part === "{limit}") return <b key={index}>{values.limit}</b>;
    return part;
  });
}

export default function QrLimitToast() {
  const { isPremium } = usePremium();
  const { qrCount, qrLimit, qrLimitWarning, qrLimitReached } = useQrCount();
  const lang = useSelector((state) => state.changeLang.language?.limitAlerts);
  const locale = useSelector((state) => state.changeLang.change);
  const forceShow = useSelector((state) => state.modals.isQrLimitForceShow);
  const dispatch = useDispatch();
  const [closedAtCount, setClosedAtCount] = useState(
    () => Number(localStorage.getItem(QR_LIMIT_CLOSED_KEY)) || 0,
  );

  useEffect(() => {
    if (qrLimitReached) {
      localStorage.removeItem(QR_LIMIT_CLOSED_KEY);
      setClosedAtCount(0);
    }
  }, [qrLimitReached]);

  if (
    isPremium || !lang || 
    (qrCount < qrLimitWarning) || 
    (qrCount === closedAtCount && !forceShow)
  ) {
    return null;
  }

  const label = qrLimitReached
      ? renderLabel(lang[1], { limit: qrLimit })
      : renderLabel(lang[0], { count: qrCount, limit: qrLimit });

  const handleUpgradeClick = () => {
    const prefix = locale !== "en" ? `/${locale}` : "";
    window.location.href = `${prefix}/pricing`;
  };

  return (
    <div
      className="qr-limit-toast position-fixed start-50 translate-middle-x d-flex justify-content-between align-items-start align-items-md-center gap-3 p-2 px-md-3 rounded-3 text-white bg-dark fs-14-18 border border-white"
    >
      <div className="d-flex gap-2 align-items-md-center">
        <BsInfoCircle className="flex-shrink-0 mt-1 mt-md-0" size={18} />
        <div className="d-flex flex-column flex-md-row gap-2 gap-md-3 align-items-start align-items-md-center">
          <span className="text-start">{label}</span>
          <Button
            variant="primary"
            size="sm"
            className="fw-bold flex-shrink-0"
            onClick={handleUpgradeClick}
          >
            {lang[2]}
          </Button>
        </div>
      </div>
      {
        !qrLimitReached &&
        <Button
          variant="link"
          className="p-0 text-white flex-shrink-0"
          onClick={() => {
            localStorage.setItem(QR_LIMIT_CLOSED_KEY, String(qrCount));
            setClosedAtCount(qrCount);
            dispatch(setIsQrLimitForceShow(false));
          }}
        >
          <BsX size={24} />
        </Button>
      }
    </div>
  );
}
